import Vue from 'vue'

const state = Vue.observable({
  showLeftSidebar: false,
  showRightSidebar: false
})

const SidebarGetters = {
  showLeftSidebar: () => state.showLeftSidebar,
  showRightSidebar: () => state.showRightSidebar
}

/**
 * @param {Boolean} val
 */
const setLeftSidebar = (val) => {
  state.showLeftSidebar = val
}

/**
 * @param {Boolean} val
 */
const setRightSidebar = (val) => {
  state.showRightSidebar = val
}

export default {
  computed: {
    showLeftSidebar: {
      get () {
        return SidebarGetters.showLeftSidebar()
      },

      set (val) {
        setLeftSidebar(val)
      }
    },

    showRightSidebar: {
      get () {
        return SidebarGetters.showRightSidebar()
      },

      set (val) {
        setRightSidebar(val)
      }
    }
  },

  methods: {
    hideSidebars () {
      this.showLeftSidebar = false
      this.showRightSidebar = false
    }
  }
}
